import { render } from "./depositPolicy.vue?vue&type=template&id=fa9157e2"
import script from "./depositPolicy.vue?vue&type=script&lang=js"
export * from "./depositPolicy.vue?vue&type=script&lang=js"

import "./depositPolicy.vue?vue&type=style&index=0&id=fa9157e2&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__